// NEXUS by ELYSIUM — owned by Kaye Witehira
import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const inst = axios.create({ baseURL: API });
inst.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nexus_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default inst;
